export default __webpack_public_path__ + "7ef4ab8613557d100ec2027f02dc07b2.png";